<script>
  import { cloneDeep } from 'lodash'
  import Select from 'svelte-select'
  import Loader from './Loader.svelte'
  import { squareItems } from './stores/root.js'

  export let handleSelect

  let item, variation

  $: variationOptions =
    item && item.value.variations ? item.value.variations : []

  $: item && variation && handleSelect(item, variation)
</script>

{#if $squareItems.length === 0}
  <Loader />
{:else}
  <div class="row">
    <div class="col-12 mb-3">
      <label for="item" class="form-label fw-bold">Item</label>
      <Select
        placeholder="Select Item"
        items={$squareItems}
        selectedValue={item}
        containerClasses="custom-select"
        on:select={(e) => {
          variation = null
          item = cloneDeep(e.detail)
        }}
        on:clear={() => {
          variation = null
          item = null
        }}
      />
    </div>

    <div class="col-12">
      <label for="type" class="form-label fw-bold">Type</label>
      <Select
        placeholder="Select Type"
        items={variationOptions}
        selectedValue={variation}
        isDisabled={!item}
        containerClasses="custom-select"
        on:select={(e) => {
          variation = cloneDeep(e.detail)
        }}
        on:clear={() => {
          variation = null
        }}
      />
    </div>
  </div>
{/if}

<style>
  :global(input) {
    font-size: 16px !important;
  }

  :global(.autocomplete.is-fullwidth) {
    display: block !important;
    background: #efefef !important;
  }

  :global(.autocomplete .form-control) {
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
  }

  :global(.autocomplete .form-control:disabled) {
    background-color: #e9ecef;
  }

  :global(.autocomplete-list-item-no-result) {
    color: #000 !important;
  }
</style>
